import { createSlice } from '@reduxjs/toolkit';

const voicesList = createSlice({
  name: 'voices',
  initialState: [],
  reducers: {
    setVoicesList: (
      _,
      action
    ) => action.payload,
  },
});

export const { setVoicesList } = voicesList.actions;
export const voicesListReducer = voicesList.reducer;
